module.exports = __webpack_public_path__ + "static/img/portinfo2.58c9328.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/portinfo2.png
// module id = hZ/z
// module chunks = 0